import "./Menu.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import DateComponent from "./DateComponent";

const MENU_ITEMS = [
  { label: "Start", path: "/" },
  { label: "Oferta", path: "/offer" },
  { label: "Galeria", path: "/gallery" },
  { label: "O mnie", path: "/about" },
  { label: "Kontakt", path: "/contact" },
];

export default function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  // Synchronizacja activeIndex z aktualną ścieżką URL (lokalizacja)
  useEffect(() => {
    const currentPath = location.pathname;
    // Znajdujemy indeks w MENU_ITEMS, który odpowiada ścieżce URL
    const foundIndex = MENU_ITEMS.findIndex(
      (item) => item.path === currentPath
    );
    if (foundIndex !== -1) {
      setActiveIndex(foundIndex);
      localStorage.setItem("activeMenuIndex", foundIndex);
    }
  }, [location.pathname]);

  const handleMenuClick = (idx) => {
    setActiveIndex(idx);
    localStorage.setItem("activeMenuIndex", idx);
    setMenuOpen(false);
    navigate(MENU_ITEMS[idx].path);
  };

  return (
    <nav className="main-nav">
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
        <span />
      </div>
      <div className="date-component">
        <DateComponent />
      </div>
      <img src={logo} alt="logo" width="80px" />

      <ul className={menuOpen ? "open" : ""}>
        {MENU_ITEMS.map((item, idx) => (
          <li key={item.path}>
            <button
              className={`menu-link montserrat-4 menu-item${
                activeIndex === idx ? " active" : ""
              }`}
              onClick={() => handleMenuClick(idx)}
            >
              {item.label}
              <span className="underline" />
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
